import React from "react";
import { Link, useLocation } from "react-router-dom";

const BreadcrumbBanner = ({ background, title }) => {
  const location = useLocation();

  // Split current path into parts (like ["campaigns", "campaign-by-id", "123"])
  const pathParts = location.pathname.split("/").filter((part) => part);

  // Generate breadcrumb links for everything except the last part (the ID)
  const crumbs = pathParts.slice(0, -1).map((part, index) => {
    const path = "/" + pathParts.slice(0, index + 1).join("/");
    const label = part.charAt(0).toUpperCase() + part.slice(1);
    return { label, path };
  });

  return (
    <div className="relative w-full h-24 sm:h-40 md:h-36 overflow-hidden">
      {/* Background Image */}
      <img
        src={background}
        alt="breadcrumb-background"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Breadcrumb */}
      <div className="relative z-10 flex items-center h-full px-4 lg:px-12">
        <nav className="text-white text-sm sm:text-base font-medium">
          <ol className="flex items-center space-x-2">
            <li>
              <Link to="/" className="hover:underline">
                Home
              </Link>
            </li>

            {/* Render all intermediate crumbs */}
            {crumbs.map((crumb, idx) => (
              <li key={idx} className="flex items-center space-x-2">
                <span>/</span>
                <Link to={crumb.path} className="hover:underline">
                  {crumb.label}
                </Link>
              </li>
            ))}

            {/* Replace last ID crumb with the passed title */}
            <li className="flex items-center space-x-2">
              <span>/</span>
              <span className="font-semibold">{title}</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default BreadcrumbBanner;
